//访客邀约路由
export default {
  path: "/visitor",
  component: () => import('../view/kscircle/index.vue'),
  children: [{
    path: "visitorMain", //访客主页面
    name: 'visitorMain', //访客主页面
    component: () => import('../view/discovery/visitor/visitorMain.vue'), //访客主页面
    props: (route) => ({
      token: route.query.token,
      koaToken: route.query.koaToken,
      userId: route.query.userId,
      deviceType: route.query.deviceType,
      deviceName: route.query.deviceName,
      secondLoginType: route.query.secondLoginType,
      secondAssessToken: route.query.secondAssessToken,
      deviceId: route.query.deviceId,
    }),
    children: [{
      path: "visitorDetails",
      name: "visitorMess",
      component: () => import('../view/discovery/visitor/visitorDetails.vue'), //访客详情页面
      props: (route) => ({
        token: route.query.token,
        koaToken: route.query.koaToken,
        userId: route.query.userId,
        deviceType: route.query.deviceType,
        deviceName: route.query.deviceName,
        secondLoginType: route.query.secondLoginType,
        secondAssessToken: route.query.secondAssessToken,
        deviceId: route.query.deviceId,
      }),
    }]

  }]

}



// WEBPACK FOOTER //
// ./src/router/visitorRouter.js